<template>
  <div class="custumer-personal-rentImpactFactors">
    <!-- 客户类型 -->
    <PieChartCard
      :title="customerTypeData.title"
      :dataDesc="customerTypeData.dataDesc"
      :dataUpdateTime="customerTypeData.dataUpdateTime"
      :dataType="customerTypeData.dataType"
      :total="customerTypeData.total"
      :totalTitle="customerTypeData.totalTitle"
      :unit="customerTypeData.unit"
      :ratioList="customerTypeData.ratioList"
      :seriesData="customerTypeData.seriesData"
    />
  </div>
</template>
<script>
import PieChartCard from '@/bizComponents/Dashboard/cards/pieChartCard/index.vue'
// eslint-disable-next-line import/no-cycle
import { getPersonRentImpactFactors } from '@/api/domain/customers'

export default {
  components: {
    PieChartCard,
  },
  data() {
    const { spId = '' } = this.$route.query
    return {
      spId,
      // 客户类型
      customerTypeData: {
        title: '客户类型',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        totalTitle: '',
        total: '',
        unit: '',
        ratioList: [],
        seriesData: [],
      },
    }
  },
  created() {
    this.getPersonRentImpactFactors()
  },
  methods: {
    async getPersonRentImpactFactors() {
      const res = await getPersonRentImpactFactors({
        spId: this.spId,
      })
      const { code, data } = res
      if (code === 1) {
        // 客户类型
        this.customerTypeData.dataUpdateTime = data?.updateTime || ''
        this.customerTypeData.seriesData = [
          {
            name: '未续约客户',
            value: data?.customerType?.unRenewalContract?.value || 0,
            ratio: data?.customerType?.unRenewalContract?.proportion || 0,
            ratioList: [
              {
                name: '日环比',
                value: data?.customerType?.unRenewalContract?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.customerType?.unRenewalContract?.weekYoY,
              },
            ],
            children: [
              {
                name: '距离计租结束小于30天客户数',
                value: data?.customerType?.rentEndDaysCustomer?.value || 0,
                ratio: data?.customerType?.rentEndDaysCustomer?.proportion || 0,
                ratioList: [
                  {
                    name: '日环比',
                    value: data?.customerType?.rentEndDaysCustomer?.dayRadio,
                  },
                  {
                    name: '周同比',
                    value: data?.customerType?.rentEndDaysCustomer?.weekYoY,
                  },
                ],
              },
              {
                name: '已租天数小于30天客户数',
                value: data?.customerType?.rentedDaysCustomer?.value || 0,
                ratio: data?.customerType?.rentedDaysCustomer?.proportion || 0,
                ratioList: [
                  {
                    name: '日环比',
                    value: data?.customerType?.rentedDaysCustomer?.dayRadio,
                  },
                  {
                    name: '周同比',
                    value: data?.customerType?.rentedDaysCustomer?.weekYoY,
                  },
                ],
              },
            ],
          },
          {
            name: '续约客户',
            value: data?.customerType?.continueCustomer?.value || 0,
            ratio: data?.customerType?.continueCustomer?.proportion || 0,
            ratioList: [
              {
                name: '日环比',
                value: data?.customerType?.continueCustomer?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.customerType?.continueCustomer?.weekYoY,
              },
            ],
          },
        ]
      }
    },
  },
}
</script>
